<div *ngIf="(viewModel$ | async) as viewModel">
  <form #subscriptionForm="ngForm">

    <div class="modal-header">
      <button type="button" (click)="onCancel()" [disabled]="viewModel.saving" class="close close-lg pull-right">&times;</button>
      <h1>
        <span>{{selectedPatient.firstName}} {{selectedPatient.middleName}} {{selectedPatient.lastName}}, </span>
        <span>{{'_destinatorType_' + selectedDestinator.type + '_' | translate }}: </span>
        <span>{{selectedDestinator.address}}</span>
      </h1>
    </div>

    <div class="modal-body">
      <div class="form-panel">
        <span class='selectSubscribeHeader'>Edit subscription settings:</span>
        <span *ngIf="viewModel.loading || viewModel.saving">
          <img style="width: 32px;" src="/img/loading.gif"/>
        </span>

        <!--div *ngIf="(contentTypes$ | async) as contentTypes"-->
        <div>
          <table class="table unsubscribedDialog" style="margin-bottom: 0;">
            <tbody>
              <tr *ngFor="let contentType of contentTypes">
                <td style="cursor: pointer;">
                  <label>
                    <input type="radio" [name]="contentType.contentType" id="{{contentType.contentType}}:green"
                           [value]="true" [(ngModel)]="contentType.isSubscribed">
                    <img class="{{'imgsub-' + contentType.group + '-' + contentType.type}}"
                         src="/img/subscribe.png"
                         [ngClass]="{'chosen' : !(contentType.isSubscribed) }"
                         tooltip="Subscribe for selected message type"/>
                  </label>
                </td>
                <td style="cursor: pointer;">
                  <label>
                    <input type="radio" [name]="contentType.contentType" id="{{contentType.contentType}}:red"
                           [value]="false" [(ngModel)]="contentType.isSubscribed">
                    <img class="{{'imgunsub-' + contentType.group + '-' + contentType.type}}"
                         src="/img/unsubscribe.png"
                         [ngClass]="{'chosen' : contentType.isSubscribed}"
                         uib-tooltip="Unsubscribe for selected message type"/>
                  </label>
                </td>
                <td style="width: 0px; background-color: #ffffff;"></td>
                <td style="width: 100%; padding: 0px;">
                  <img class="messageTypeIcon" src="{{contentType.img}}"/>
                  <span>{{contentType.name}}</span>
                </td>
              </tr>

            </tbody>
          </table>

        </div>
      </div>
    </div>

    <div class="modal-footer">

      <button type="submit"
              class="btn btn-primary"
              [disabled]="viewModel.saving"
              (click)="saveChanges()"
              name="update-settings-btn"
              [disabled]="subscriptionForm.pristine"
      ><span *ngIf="!viewModel.saving">Save</span><span *ngIf="viewModel.saving">Saving <img style="width: 16px;" src="/img/loading.gif"/></span>
      </button>
      <button type="button"
              [disabled]="viewModel.saving"
              class="btn btn-default"
              (click)="onCancel()"
      >Cancel
      </button>
    </div>

  </form>

</div>